/**
 * assets/alb-anchor-scroll.js  ·  ALB Horizon
 *
 * Sprungmarken (<a href="#ziel">) funktionsfaehig machen.
 *
 * Horizon scrollt ab 990px nicht das Dokument, sondern den .page-wrapper
 * (base.css: html/body bekommen overflow:hidden, .page-wrapper overflow-y:auto,
 * siehe assets/scroll-container.js). Die native Fragment-Navigation scrollt aber
 * ausschliesslich document.scrollingElement – und der kann dort gar nicht mehr
 * scrollen. Ergebnis ohne diesen Helfer: Der Hash landet in der URL, die Seite
 * bleibt aber stehen (betrifft alle #-Links, u. a. alb-anker-menue, die LP-CTAs
 * und den Berater-Button im Hero).
 *
 * scrollIntoView() kennt verschachtelte Scroll-Container und beachtet zugleich
 * scroll-margin-top (.alb-anchor: 100px, damit der Sticky-Header nicht deckt).
 */
(function () {
  'use strict';

  /** Ziel eines Fragments suchen – id zuerst, dann name (Alt-Anker). */
  function findTarget(hash) {
    if (!hash || hash.length < 2 || hash.charAt(0) !== '#') return null;
    var raw = hash.slice(1);
    var decoded = raw;
    try {
      decoded = decodeURIComponent(raw);
    } catch (e) {
      /* kaputte Escapes: mit dem Rohwert weitersuchen */
    }
    return (
      document.getElementById(decoded) ||
      document.getElementById(raw) ||
      document.getElementsByName(decoded)[0] ||
      null
    );
  }

  /** Hart setzen (ohne Animation). 'instant' statt 'auto': 'auto' erbt das
   *  CSS scroll-behavior des Containers – und .page-wrapper steht auf smooth. */
  function setHard(el) {
    try {
      el.scrollIntoView({ behavior: 'instant', block: 'start' });
    } catch (e) {
      el.scrollIntoView(true); // Browser ohne 'instant' im ScrollBehavior-Enum
    }
  }

  /**
   * Nach dem Scrollen einmal nachjustieren.
   *
   * Waehrend einer langen Scrollfahrt (Startseiten-Hero -> Berater sind ~6
   * Screens) laden die ueberflogenen Sections nach und schieben das Ziel
   * weiter – ohne Korrektur landet man daneben (gemessen: 40px). Sobald die
   * Bewegung steht, wird die Restdifferenz zur scroll-margin-top gesetzt.
   * Scrollt der Nutzer selbst mit, wird abgebrochen – niemand mag es, wenn
   * die Seite unter dem Finger wegspringt.
   */
  var USER_INPUT = ['wheel', 'touchstart', 'pointerdown', 'keydown'];

  function correctAfterScroll(el) {
    var startTop = el.getBoundingClientRect().top;
    var lastTop = null;
    var stable = 0;
    var frames = 0;
    var moved = false;
    var aborted = false;

    function abort() {
      aborted = true;
    }
    function cleanup() {
      for (var i = 0; i < USER_INPUT.length; i++) {
        window.removeEventListener(USER_INPUT[i], abort);
      }
    }
    for (var i = 0; i < USER_INPUT.length; i++) {
      window.addEventListener(USER_INPUT[i], abort, { passive: true });
    }

    (function tick() {
      if (aborted) return cleanup();
      if (++frames > 300) return cleanup(); // ~5 s Notbremse

      var top = el.getBoundingClientRect().top;
      if (Math.abs(top - startTop) > 4) moved = true;
      if (!moved) return requestAnimationFrame(tick); // Animation laeuft noch an

      if (lastTop !== null && Math.abs(top - lastTop) < 0.5) stable++;
      else stable = 0;
      lastTop = top;
      if (stable < 4) return requestAnimationFrame(tick);

      // Steht: sitzt das Ziel auf seiner scroll-margin-top (100px, .alb-anchor)?
      var margin = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
      if (Math.abs(top - margin) > 2) setHard(el);
      cleanup();
    })();
  }

  function jumpTo(el) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      setHard(el);
      return;
    }
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    correctAfterScroll(el);
  }

  document.addEventListener(
    'click',
    function (event) {
      // Modifier-Klicks, Mittelklick und bereits behandelte Klicks (Tabs,
      // Accordions o. ae.) dem Browser bzw. der Komponente ueberlassen.
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var node = event.target;
      var link = node && node.closest ? node.closest('a[href]') : null;
      if (!link || link.hasAttribute('download')) return;
      if (link.target && link.target !== '' && link.target !== '_self') return;

      // Nur reine Seiten-interne Sprungmarken – "/pfad#ziel" ist eine Navigation.
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;

      var target = findTarget(href);
      if (!target) return; // Ziel existiert nicht: Browser-Default nicht kapern.

      event.preventDefault();
      jumpTo(target);

      // Hash nachziehen (teilbare URL wie bei nativer Fragment-Navigation).
      // pushState loest bewusst kein hashchange aus – sonst wuerden Sections,
      // die selbst am Hash haengen (Produktberater, Camping-Konfigurator),
      // doppelt reagieren.
      if (window.history && typeof history.pushState === 'function') {
        try {
          history.pushState(null, '', href);
        } catch (e) {
          /* z. B. blockiert im Theme-Editor-iframe – Sprung ist trotzdem passiert */
        }
      }
    },
    false
  );

  // Direkteinstieg mit Fragment in der URL (Link aus Newsletter, Suche, Share).
  // Erst nach 'load', damit Lazy-Bilder die Zielposition nicht mehr verschieben.
  // Hier bewusst hart setzen statt zu scrollen: Wer die URL mit #ziel oeffnet,
  // will dort ankommen und nicht erst am Seitenanfang losfahren.
  window.addEventListener('load', function () {
    var target = findTarget(window.location.hash);
    if (!target) return;
    // Ein Frame Abstand: Horizon setzt die Scrollposition beim Laden selbst.
    requestAnimationFrame(function () {
      setHard(target);
    });
  });
})();
